import { Label } from '@/components/ui/label'
import { cn } from '@/lib/cn'
import { AlertCircle } from 'lucide-react'
import type { ReactNode } from 'react'

interface Props {
  label: string
  error?: string
  required?: boolean
  hint?: string
  htmlFor?: string
  children: ReactNode
  className?: string
}

export function FormField({ label, error, required, hint, htmlFor, children, className }: Props) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <Label htmlFor={htmlFor} className={cn(error && 'text-rose-600 dark:text-rose-400')}>
        {label}
        {required ? <span className="ml-0.5 text-muted-foreground">*</span> : null}
      </Label>
      {children}
      {hint && !error ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
      {error ? (
        <p className="flex items-center gap-1 text-xs text-rose-600 dark:text-rose-400">
          <AlertCircle className="h-3 w-3 shrink-0" />
          <span>{error}</span>
        </p>
      ) : null}
    </div>
  )
}
